import { render } from "./App.vue?vue&type=template&id=77f26012"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=77f26012&lang=scss"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__